// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}.pp-app{display:inline-block;min-width:100px;--pp-theme-color:#656e8b;--pp-primary-button-text-color:#fff}.widget-list-open{display:flex;height:var(--pp-parent-height,100vh);width:var(--pp-parent-width,100vw)}.widget-list-open:after{background-color:#000;content:\"\";height:var(--pp-parent-height,100vh);left:0;opacity:.5;pointer-events:none;position:absolute;top:0;width:100%;z-index:-1}", ""]);
// Exports
module.exports = exports;
